import React from 'react';
import { Link } from 'react-router-dom';
import translations from '../../translation'; // Import the translations

const PendingApprovals = ({ content, language }) => {
  const translate = (key) => translations[language]?.[key] || key;

  return (
    <Link to="/approver/pending">
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <i className="fas fa-clock text-custom text-3xl" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  {translate('pendingAnnouncements')}
                </dt>
                <dd className="text-3xl font-semibold text-gray-900">{content}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PendingApprovals;
